import { ListStickerWorkOrdersResponse } from '../WorkOrders/WorkOrders.types';
import { WorkOrderQRCodeResponse } from './QRCode.types';
import { publicInstance } from '@/api/axiosInstance';

export async function getWorkOrderByGuid(guid: string) {
  const result = await publicInstance.get<WorkOrderQRCodeResponse>(
    `/workorder/v1/QRCode/workorder?Id=${guid}`,
  );

  return result.data;
}

export async function getWorkOrdersStickerByToken(token: string) {
  const result = await publicInstance.get<ListStickerWorkOrdersResponse[]>(
    `/workorder/v1/QRCode/sticker?Token=${token}`,
  );

  return result.data;
}
